import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  private isShowingAuthError = false; // Prevent multiple auth error dialogs

  constructor(private authService: AuthService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getToken();
    
    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    return next.handle(req).pipe(
      catchError((err) => {
        // Handle country blocking (403 with type: country_blocked)
        if (err.status === 403 && err.error?.type === 'country_blocked') {
          this.handleCountryBlocked(err.error);
          return throwError(() => err);
        }

        // Handle 401 Unauthorized errors
        if (err.status === 401) {
          // Only show the error dialog once to avoid spam
          if (!this.isShowingAuthError) {
            this.isShowingAuthError = true;

            Swal.fire({
              icon: 'warning',
              title: 'Session expirée',
              text: 'Veuillez vous reconnecter.',
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then(() => {
              this.isShowingAuthError = false;
            });
          }

          // Clear session and redirect
          this.authService.logout();
        }

        return throwError(() => err);
      })
    );
  }

  private handleCountryBlocked(errorData: any): void {
    Swal.fire({
      icon: 'error',
      title: errorData.title || 'Accès refusé',
      text: errorData.message || 'Votre pays est restreint pour accéder à ce site',
      confirmButtonText: 'OK',
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then(() => {
      // Clear session and redirect to login
      this.authService.logout();
    });
  }
}